import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import NotificationBox from 'components/notification_box/notification_box'

import styles from './overlay_notification.scss'

class OverlayNotification extends PureComponent {

	render() {
		return (
			<div styleName={cn({
				wrapper: true,
				'bg--transparent': this.props.transparent,
				'bg-light-blue': this.props.color === 'light-blue',
				'bg-blue': this.props.color === 'blue',
			})}>
				<div styleName='content'>
					<NotificationBox
						icon={this.props.icon}
						title={this.props.title}
						text={this.props.text}
						btOne={this.props.btOne}
						btTwo={this.props.btTwo}
						actionOne={this.props.actionOne}
						actionTwo={this.props.actionTwo}
						canEdit={this.props.canEdit}
						actionButtonType={this.props.actionButtonType}
						iconBackground={this.props.iconBackground} />
				</div>
			</div>
		)
	}

}

OverlayNotification.defaultProps = {
	color: 'light-blue',
	transparent: false,
	icon: null,
	title: null,
	text: null,
	secondaryText: null,
	btOne: '',
	actionOne: () => {},
	btTwo: '',
	actionTwo: () => {},
	canEdit: false,
	actionButtonType: null,
	iconBackground: 'blue',
}

OverlayNotification.propTypes = {
	color: PropTypes.oneOf(['light-blue', 'blue']),
	transparent: PropTypes.bool,
	icon: PropTypes.object,
	title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	btOne: PropTypes.string,
	actionOne: PropTypes.func,
	btTwo: PropTypes.string,
	actionTwo: PropTypes.func,
	canEdit: PropTypes.bool,
	actionButtonType: PropTypes.number,
	iconBackground: PropTypes.oneOf(['blue', 'transparent']),
}

export default CSSModules(OverlayNotification, styles, {allowMultiple: true})
